<template>
    <div>
        <Head><title>Revenue Share -Details</title></Head>
        <h1 class="mb-8 text-3xl font-bold">
            <Link class="text-indigo-400 hover:text-indigo-600" href="/revenue-share">Revenue Share</Link>
            <span class="text-indigo-400 font-medium">/</span>
            Details
        </h1>
    </div>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
        <form @submit.prevent="update">
            <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                <text-input v-model="form.project" :error="form.errors.project" class="pb-8 pr-6 w-full lg:w-1/2"
                            label="Project"/>
                <text-input v-model="form.organization_share" :error="form.errors.organization_share"
                            class="pb-8 pr-6 w-full lg:w-1/2" label="Organization Share">
                </text-input>

                <text-input v-model="client_share" :error="form.errors.client_share"
                            class="pb-8 pr-6 w-full lg:w-1/2" label="Client Share" readonly/>

                <small>use decimal place max eg 0.6</small>

            </div>
            <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                <button class="text-red-600 hover:underline" tabindex="-1" type="button"
                        @click="destroy">Delete
                </button>
                <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Update
                </loading-button>
            </div>
        </form>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
    components: {
        FileInput,
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        TrashedMessage,
    },
    layout: Layout,
    props: {
        revenueShare: Object,
        projects: Array,
    },
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                _method: 'put',
                project: this.revenueShare.project,
                organization_share: this.revenueShare.organization_share,
                client_share: this.client_share,
            }),
        }
    },
    methods: {
        update() {
            this.form.put(`/revenue-share/${this.revenueShare.id}`, {})
        },
        destroy() {
            if (confirm('Are you sure you want to delete this Share Ratio?')) {
                this.$inertia.delete(`/revenue-share/${this.revenueShare.id}`)
            }
        },
    },
    computed: {
        client_share: {
            get() {
                return (1 - this.form.organization_share).toFixed(1);
            },
            set(val) {

            }
        }
    }
}
</script>
